/**
 * Invoke `cb` once, on the first `keydown` or `pointerdown` on `target`, then remove the listeners.
 * Browsers refuse to start audio until the user has gestured at the page; this is the standard
 * unlock hook. Returns a cleanup that removes the listeners early (if the gesture never happens,
 * e.g. the app is torn down first).
 */
export function onFirstGesture(target: Window, cb: () => void): () => void {
  function handler(): void {
    cleanup();
    cb();
  }
  function cleanup(): void {
    target.removeEventListener("keydown", handler);
    target.removeEventListener("pointerdown", handler);
  }
  target.addEventListener("keydown", handler);
  target.addEventListener("pointerdown", handler);
  return cleanup;
}
